/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { StringSchema } from 'yup';

export function stringEmptyTransform(this: StringSchema, value: any) {
  // if its valid type return the value, otherwise return an empty string
  return this.isType(value) ? value : '';
}
